<template>
  <g>
    <template v-for="(e, i) in doors">
      <!-- door handle -->
      <rect
        v-for="i in [0, 1]"
        :key="`${e.key}:node${i}`"
        class="door-node"
        :style="circleStyles"
        v-bind="doorProps(e, i)"
        @mousedown="
          onClickDoor($event, { i: e.nodes[0], j: e.nodes[1], n: e.index })
        "
      ></rect>
      <!-- door edge -->
      <line
        :key="e.key + ':line'"
        class="door"
        :style="doorStyle(e.name)"
        :data-index="i"
        v-bind="e.pos"
        @mousedown="
          onClickDoor($event, { i: e.nodes[0], j: e.nodes[1], n: e.index })
        "
      />
    </template>
  </g>
</template>

<script>
import { inject, toRefs } from "@vue/composition-api";
import useBasicStyles from "@/composables/useBasicStyles";
import ui from "@/store/modules/ui";

export default {
  props: {
    EdgesSymbol: Symbol,
    shouldBlock: Boolean
  },
  setup(props) {
    //
    // Props
    // -------------------------------------------------------------------
    //
    const { shouldBlock } = toRefs(props);
    const { EdgesSymbol } = props;
    //
    // Composables
    // ---------------------------------------------------------------
    //
    const edgesComposable = inject(EdgesSymbol);
    const { doors, removeDoorTool: removeDoor } = edgesComposable;
    const { circleStyles, lineStyle } = useBasicStyles();
    //
    // Events: Click on Edge
    // -------------------------------------------------------------------
    //
    //
    function onClickDoor(e, { i, j, n }) {
      if (shouldBlock.value) return;
      notifyChange();

      switch (ui.annoType) {
        case "remove":
          removeDoor(e, { i, j, n });
      }
    }
    function notifyChange() {
      if (!ui.hasUnsavedChange) {
        ui.setHasUnsavedChange(true);
      }
    }
    // Styles
    // -------------------------------------------------------------------
    //
    function doorStyle(name) {
      const style = {};
      if (!name) {
        style.stroke = "#ff0";
      } else if (name === "door") {
        style.stroke = "#ff0";
      } else if (name === "window") {
        style.stroke = "#00f";
      }
      return {
        ...lineStyle.value,
        ...style
      };
    }
    const doorProps = (door, index) => {
      const res = {
        width: ui.circleRadius * 1.5,
        height: ui.circleRadius * 1.5
      };
      if (index == 0) {
        res.x = door.pos.x1 - ui.circleRadius * 0.75;
        res.y = door.pos.y1 - ui.circleRadius * 0.75;
      } else {
        res.x = door.pos.x2 - ui.circleRadius * 0.75;
        res.y = door.pos.y2 - ui.circleRadius * 0.75;
      }
      return res;
    };

    return {
      doors,
      circleStyles,
      doorStyle,
      doorProps,
      onClickDoor
    };
  }
};
</script>

<style lang="scss" scoped>
.door {
  // stroke: black;
  stroke-dasharray: 3, 3;
}
.door:hover {
  stroke: var(--stroke-hover);
}
.door-node {
  fill: black;
}
.door-node:hover {
  stroke: greenyellow;
  stroke-width: var(--stroke-width-hover);
}
</style>
